import { HashRouter, Route, Redirect, Switch } from 'react-router-dom'
import React, { useEffect } from 'react'
import zhCN from 'antd/es/locale-provider/zh_CN'
import enUS from 'antd/es/locale-provider/en_US'
import { ConfigProvider } from 'antd'
// import ReactDOM from 'react-dom'
import { IntlProvider } from 'react-intl'
import createLoading from 'dva-loading'
import useLang from '@/utils/lang'
import routerConfig from '@/config/router.config'
import { getUniqId, getQueryParams, getLocale } from '@/utils'
import zh from './assets/locales/zh'
import en from './assets/locales/en'
import app from './dva'
import NotFound from './pages/NotFound'

const langList = ['zh', 'en']
const IntlProviderWrapper = props => {
  const { children } = props
  const [lang, changeLang] = useLang()
  let initMessages
  let local
  switch (lang) {
    case 'zh':
      initMessages = zh
      local = zhCN
      document.title = '小米信任中心'
      break
    case 'en':
      initMessages = en
      local = enUS
      document.title = 'Xiaomi Trust Center'
      break
    default:
      break
  }
  useEffect(() => {
    const handler = e => {
      const oldLang = getLocale(e.oldURL)
      const newLang = getQueryParams('locale', e.newURL)
      if (langList.indexOf(newLang) < 0) {
        changeLang(lang)
      } else if (oldLang !== newLang) {
        changeLang(newLang)
      }
    }
    window.addEventListener('hashchange', handler)
    return () => {
      window.removeEventListener('hashchange', handler)
    }
  }, []) // eslint-disable-line

  return (
    <IntlProvider
      locale={lang}
      messages={initMessages}
    >
      <HashRouter>
        <ConfigProvider locale={local}>
          {children}
        </ConfigProvider>
      </HashRouter>
    </IntlProvider>
  )
}

const RouteInstanceMap = {
  get(key) {
    return key.$$$routeInternalComponent
  },
  has(key) {
    return key.$$$routeInternalComponent !== undefined
  },
  set(key, value) {
    key.$$$routeInternalComponent = value
  },
}

// Support pass props from layout to child routes
const RouteWithProps = ({
  path,
  exact,
  strict,
  render,
  location,
  sensitive,
  ...rest
}) => (
  <Route
    path={path}
    exact={exact}
    strict={strict}
    location={location}
    sensitive={sensitive}
    render={props => render({ ...props, ...rest })}
  />
)

function withRoutes(route) {
  if (RouteInstanceMap.has(route)) {
    return RouteInstanceMap.get(route)
  }

  const { Routes } = route
  let len = Routes.length - 1
  let Component = args => {
    const { render, ...props } = args
    return render(props)
  }
  while (len >= 0) {
    const AuthRoute = Routes[len]
    const OldComponent = Component
    Component = props => (
      <AuthRoute {...props}>
        <OldComponent {...props} />
      </AuthRoute>
    )
    len -= 1
  }

  const ret = args => {
    const { render, ...rest } = args
    return (
      <RouteWithProps
        {...rest}
        render={props => {
          return <Component {...props} route={route} render={render} />
        }}
      />
    )
  }
  RouteInstanceMap.set(route, ret)
  return ret
}

function renderRoutes(
  routes,
) {
  return routes ? (
    <Switch>
      {routes.map(route => {
        if (route.redirect) {
          return (
            <Redirect
              key={route.key || getUniqId()}
              from={route.path}
              to={route.redirect}
              exact={route.exact}
              strict={route.strict}
            />
          )
        }
        const RouteRoute = route.Routes ? withRoutes(route) : RouteWithProps
        return (
          <RouteRoute
            key={route.key || getUniqId()}
            path={route.path}
            exact={route.exact}
            strict={route.strict}
            sensitive={route.sensitive}
            render={props => {
              const childRoutes = renderRoutes(
                route.routes,
              )
              if (route.component) {
                return (
                  <route.component {...props}>
                    {childRoutes}
                  </route.component>
                )
              }
              return childRoutes
            }}
          />
        )
      })}
      <Route component={NotFound} />
    </Switch>
  ) : null
}

function Router() {
  let routeNode
  if (window.location.href === 'https://privacy.mi.com/trust#/') {
    window.location.href = 'https://trust.mi.com'
  } else if (window.location.href === 'https://preview.privacy.mi.com/trust#/') {
    window.location.href = 'http://trust-center-cl45206.staging.ingress.mice.cc.d.xiaomi.net'
  } else {
    routeNode = renderRoutes(routerConfig, true)
  }
  return (
    <IntlProviderWrapper>
      {routeNode}
    </IntlProviderWrapper>
  )
}

app.use(createLoading())
app.router(Router)
app.start('#root')
